import AXIOS from "./axios";

export default class Institutions {
  static async fetchInstitutions(payload) {
    return AXIOS.get("/institutions", { params: payload });
  }

  static async fetchInstitution(id) {
    return AXIOS.get(`/institutions/${id}`);
  }

  static async fetchInstitutionUnits(id) {
    return AXIOS.get(`/institutions/${id}/units`);
  }
}
